import { Card, CardContent, CardHeader, Grid, IconButton } from '@mui/material';
import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import { useParams } from 'react-router-dom';
import { FormTextField, HiddenField } from 'shared/controls';
import { PdfProductForm, Brands } from 'shared/types';
import { buildFieldNameWithIndex } from 'shared/utility';

interface PdfProductFieldsProps {
  product: PdfProductForm;
  index: number;
  moveUp(): void;
  moveDown(): void;
  disableMoveUp: boolean;
  disableMoveDown: boolean;
}
export function PdfProductFields({
  index,
  moveDown,
  moveUp,
  disableMoveDown: disableBottom,
  disableMoveUp: disableTop,
}: PdfProductFieldsProps) {
  const buildFieldName = buildFieldNameWithIndex<PdfProductForm>(index);
  const { brand } = useParams<{ brand: Brands }>();
  const isNianticBrand: boolean = brand === 'nianticseal';
  return (
    <Grid item xs={12}>
      <Card elevation={2}>
        <CardHeader
          action={
            <>
              <IconButton disabled={disableBottom} onClick={moveDown}>
                <ArrowDownward />
              </IconButton>
              <IconButton disabled={disableTop} onClick={moveUp}>
                <ArrowUpward />
              </IconButton>
            </>
          }
        />
        <CardContent>
          <Grid container spacing={1} justifyContent='center' alignItems='center'>
            <Grid item container spacing={1}>
              <Grid item xs={12} md={4}>
                <FormTextField label='Product Number' name={buildFieldName('itemId')} />
              </Grid>
              <Grid item xs={12} md={4}>
                <FormTextField label='Product Name' name={buildFieldName('name')} />
              </Grid>
              <Grid item xs={12} md={4}>
                <FormTextField label='Product Extended Description' name={buildFieldName('extendedDesc')} />
              </Grid>
              {isNianticBrand && (
                <Grid item xs={12} md={4}>
                  <FormTextField label='Customer Product Number' name={buildFieldName('customerProductNumber')} />
                </Grid>
              )}
            </Grid>
            <Grid item xs={12}>
              <FormTextField
                label='Line Item Notes'
                name={buildFieldName('notes')}
                readOnly={false}
                multiline
                minRows={3}
                maxRows={10}
                fullWidth
              />
            </Grid>
          </Grid>
          <HiddenField name={buildFieldName('quantity')} />
          <HiddenField name={buildFieldName('revisedPrice')} />
          <HiddenField name={buildFieldName('extendedPrice')} />
        </CardContent>
      </Card>
    </Grid>
  );
}
